import type { GameManifest } from '../../contracts/game';

export const sausageSimulatorManifest: GameManifest = {
  id: 'sausage-simulator',
  title: 'Sausage Simulator',
  version: '0.4.3',
  status: 'playable',
  coverAsset: '/covers/sausage-simulator.jpg',
  catalogOrder: 3,
  preferredAspectRatio: 16 / 9,
  supportsCpu: false,
  load: () => import('./index'),
};
